import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { BASE_URL } from "../config/axios";
import usePermission from "../config/permissions";
import { adminAiMantraPathPrefix, isAdminAiMantraRole } from "../config/roles";

import { sidebarData } from "../pages/contractorDashboard/ContractorSidebar";
import { sidebarDataAdmin } from "../pages/adminDashboard/AdminSidebar";

import consailogo from "../../src/assets/images/consailogo.png";
import { User } from "lucide-react";

const AddModals = lazy(() =>
  import("../components/modals/AddModals").then((module) => ({
    default: module.AddModals,
  })),
);
const DashboardSidebar = lazy(() => import("./DashboardSidebar"));
const Header = () => {
  const { role, userProfile } = usePermission();
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "";
  const isLoginPage = location.pathname === "/login";
  const isSignupPage = location.pathname === "/signup";
  const isDemoPage =
    location.pathname === "/requestdemo" ||
    location.pathname.endsWith("/requestdemo");
  const [isLoggedIn, setIsLoggedIn] = useState(
    Boolean(sessionStorage.getItem("access_token")),
  );
  const [menuOpen, setMenuOpen] = useState(false);
  const [isexpand, setExpanded] = useState(false);

  const menuRef = useRef(null);

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const Gotologin = () => {
    navigate("/login");
  };

  const GotoSignup = () => {
    navigate("/signup");
  };

  const GotoDemo = () => {
    navigate("/requestdemo");
  };

  const home = () => {
    if (role == "8700957700") {
      navigate(`admin/tenderlist`);
    }

    if (isAdminAiMantraRole(role)) {
      navigate(`${adminAiMantraPathPrefix(role)}/tenderlist`);
    }

    if (role === "Contractor") {
      navigate(`contractor/tenderlist`);
    }

    if (role === "Accounts") {
      navigate(`account/tenderlist`);
    }

    if (role === "employee") {
      navigate(`employee/tenderlist`);
    }
    if (role === null) {
      navigate("/");
    }
  };

  const GotoHomepage = () => {
    if (sessionStorage.getItem("customer_id")) {
      navigate("/tenderlist");
    } else {
      navigate("/guesttenderdetails");
    }
  };

  const GotoProfile = () => {
    setMenuOpen(!menuOpen);
    setShowDropdown(false);

    if (role == "8700957700") {
      navigate(`admin/profilepage`);
    }

    if (isAdminAiMantraRole(role)) {
      navigate(`${adminAiMantraPathPrefix(role)}/profilepage`);
    }

    if (role === "Contractor") {
      navigate(`contractor/profilepage`);
    }

    if (role === "Accounts") {
      navigate(`account/profilepage`);
    }

    if (role === "employee") {
      navigate(`employee/profilepage`);
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setShowDropdown(false);
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("customer_id");
    sessionStorage.removeItem("role");

    window.location.reload();
    navigate("/");
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const GotoAdminpage = () => {
    setMenuOpen(!menuOpen);
    navigate("admin/tenderSubscriptionFormats");
  };

  const gotMytender = () => {
    setMenuOpen(!menuOpen);
    setShowDropdown(false);
    if (role == "8700957700") {
      navigate(`admin/mytender`);
    }

    if (role === "Contractor") {
      navigate(`contractor/mytender`);
    }

    if (role === "Accounts") {
      navigate(`account/mytender`);
    }

    if (role === "9882641949") {
      navigate(`employee/mytender`);
    }
  };

  const customer_id = sessionStorage.getItem("customer_id");
  const token = sessionStorage.getItem("access_token");
  const effectiveRole = role || sessionStorage.getItem("role");
  const showWorkspaceMenu = Boolean(token && customer_id);
  const isAdminMenu =
    effectiveRole === "8700957700" ||
    isAdminAiMantraRole(effectiveRole) ||
    effectiveRole === "aiadmin";

  const [profile, setProfile] = useState([]);
  const fetchTenderData = async (id) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/user/userviewbyemail/${id}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setProfile(response.data);
      setIsLoggedIn(true);
    } catch (error) {
    } finally {
    }
  };

  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  useEffect(() => {
    if (customer_id) {
      fetchTenderData(customer_id);
    }
  }, [customer_id]);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  return (
    <>
      <header className={`headers${showWorkspaceMenu ? " headers--workspace" : ""}`}>
        <div className={`header-content${showWorkspaceMenu ? " header-content--split" : ""}`}>
          <div className="header-left">
            <h1 className="brand-logo-text" onClick={home}>
              <span>
                <img
                  src={consailogo}
                  alt="Consult AI"
                  className="brand-logo-img"
                />
              </span>
            </h1>
          </div>
          {showWorkspaceMenu ? (
            <Suspense fallback={null}>
              <DashboardSidebar
                sidebarData={isAdminMenu ? sidebarDataAdmin : sidebarData}
                isexpand={isexpand}
                setExpanded={setExpanded}
              />
            </Suspense>
          ) : null}

          <nav className={`nav-links ${menuOpen ? "" : ""}`}>
            {(effectiveRole === "8700957700" ||
              isAdminAiMantraRole(effectiveRole)) && (
              <div className="flex-row gapss10">
                <div>
                  <Suspense fallback={null}>
                    <AddModals />
                  </Suspense>
                </div>
              </div>
            )}

            {isLoggedIn ? (
              <ul className="user-profile">
                <div className="user-avatar" ref={menuRef}>
                  <button
                    type="button"
                    className="user-avatar-btn"
                    onClick={toggleDropdown}
                    aria-label="Open profile menu"
                    aria-haspopup="menu"
                    aria-expanded={showDropdown}
                  >
                    <span className="user-info">
                      <span className="username">
                        {profile?.name_of_person || "Account"}
                      </span>
                      {profile?.designation ? (
                        <span className="user-role">{profile.designation}</span>
                      ) : null}
                    </span>
                    <span className="user-avatar-icon" aria-hidden="true">
                      <User size={15} strokeWidth={2} />
                    </span>
                  </button>

                  {showDropdown && (
                    <div className="profile-menu" role="menu">
                      <div
                        className="menu-item"
                        role="menuitem"
                        onClick={GotoProfile}
                      >
                        My Profile
                      </div>
                      <div
                        className="menu-item logout"
                        role="menuitem"
                        onClick={() => {
                          setShowDropdown(false);
                          setShowLogoutPopup(true);
                        }}
                      >
                        Logout
                      </div>
                    </div>
                  )}
                </div>
              </ul>
            ) : (
              <>
                {isHome && (
                  <div className="public-page-nav" aria-label="On this page">
                    <a href="#how-it-works">Product</a>
                    <a href="#pricing" data-consai-guide="landing-pricing">Pricing</a>
                  </div>
                )}
                <div className="headers-buttons">
                  <li className="header-guest-item">
                    <button
                      title="Browse tenders without an account"
                      className="btn-secondary"
                      data-consai-guide="landing-browse"
                      onClick={GotoHomepage}
                      style={{ cursor: "pointer" }}
                    >
                      Browse
                    </button>
                  </li>
                  {!isDemoPage && (
                    <li className="header-demo-item">
                      <button
                        title="Request a product demo"
                        className="btn-secondary"
                        data-consai-guide="landing-demo"
                        onClick={() => {
                          GotoDemo();
                          toggleMenu();
                        }}
                      >
                        Demo
                      </button>
                    </li>
                  )}
                  {!isLoginPage && (
                    <li className="header-login-item">
                      <button
                        title="login"
                        className="btn-secondary"
                        data-consai-guide="landing-login"
                        onClick={() => {
                          Gotologin();
                          toggleMenu();
                        }}
                      >
                        Log in
                      </button>
                    </li>
                  )}
                  {!isSignupPage && (
                    <li className="header-signup-item">
                      <button
                        title="new-acc"
                        className="btn-primary"
                        data-consai-guide="landing-signup"
                        onClick={() => {
                          GotoSignup();
                          toggleMenu();
                        }}
                      >
                        Sign up
                      </button>
                    </li>
                  )}
                </div>
              </>
            )}
          </nav>
        </div>
      </header>
      {showLogoutPopup && (
        <div
          className="logout-overlay"
          onClick={() => setShowLogoutPopup(false)}
        >
          <div
            className="logout-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="logout-title"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 id="logout-title">Sign out</h3>
            <p>You will need to log in again to access your workspace.</p>

            <div className="logout-actions">
              <button
                type="button"
                className="btn-cancel"
                onClick={() => setShowLogoutPopup(false)}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn-logout"
                onClick={() => {
                  setShowLogoutPopup(false);
                  handleLogout();
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
